import React, { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info';

interface ToasterProps {
    message: string;
    type?: ToastType;
    duration?: number;
    onClose: () => void;
}

export default function Toaster({ message, type = 'info', duration = 3000, onClose }: ToasterProps) {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`bs-toaster bs-toaster--${type}`}>
            <span className='bs-toaster__message'>{message}</span>
            <button
                className='bs-toaster__close'
                onClick={e => {
                    e.preventDefault();
                    onClose();
                }}
                aria-label='Close'
            >
                ×
            </button>
        </div>
    );
}
